"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Types = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@emotion/react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Row = _interopRequireDefault(require("../layout/Row"));
var _Typography = _interopRequireDefault(require("../atoms/Typography"));
var _Icon = _interopRequireDefault(require("../atoms/Icon"));
var _utils = require("../../utils");
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let Types = exports.Types = /*#__PURE__*/function (Types) {
  Types["Success"] = "success";
  Types["Error"] = "error";
  Types["Info"] = "info";
  Types["Warning"] = "warning";
  return Types;
}({});
const defaultProps = {
  type: Types.Info,
  textSize: 14,
  iconSize: 18,
  textStyles: '',
  className: ''
};
function StatusChip(props) {
  var _colors$MAIN;
  const {
    containerStyles,
    type,
    text,
    textColor,
    textSize,
    iconSize,
    textStyles,
    className
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const {
    colors
  } = (0, _react2.useTheme)();
  const iconTypeMap = {
    [Types.Success]: 'check_circle',
    [Types.Error]: 'cancel',
    [Types.Info]: 'error',
    [Types.Warning]: 'watch_later'
  };
  return /*#__PURE__*/_react.default.createElement(_Row.default, {
    gap: 5,
    className: className,
    styles: containerStyles
  }, /*#__PURE__*/_react.default.createElement(CheckIcon, {
    name: iconTypeMap === null || iconTypeMap === void 0 ? void 0 : iconTypeMap[type === null || type === void 0 ? void 0 : type.toLowerCase()],
    type: type,
    size: iconSize
  }), text && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: textColor || ((_colors$MAIN = colors.MAIN) === null || _colors$MAIN === void 0 ? void 0 : _colors$MAIN[String(type).toUpperCase()]),
    weight: 700,
    size: textSize,
    styles: textStyles,
    "data-element": "status-chip-text"
  }, text));
}
const CheckIcon = (0, _styled.default)(_Icon.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), _ref => {
  var _theme$colors$MAIN;
  let {
    theme,
    type
  } = _ref;
  const mainColor = ((_theme$colors$MAIN = theme.colors.MAIN) === null || _theme$colors$MAIN === void 0 ? void 0 : _theme$colors$MAIN[String(type).toUpperCase()]) || (theme === null || theme === void 0 ? void 0 : theme.colors.MAIN.PRIMARY);
  return "\n      border-radius: 25px;\n      padding: 3px;\n      background: ".concat((0, _utils.hexToRGBA)(mainColor, 0.15), ";\n      border: 1px solid ").concat(mainColor, ";\n      color: ").concat(mainColor, ";\n    ");
});
var _default = exports.default = StatusChip;